module.exports = __webpack_public_path__ + "static/media/ad.3e8a405d.jpg";